import { FeedbackState } from './feedback';

export const feedbackDefaultState: FeedbackState = {
    programsFeedback: {},
};
